export default __webpack_public_path__ + "static/media/marin2.1feaf3a2.jpg";